import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { SecurityIcon } from './SecurityIcon.jsx';
import { FaronexoLogo } from './FaronexoLogo.jsx';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-primary/30 text-foreground pt-16 pb-8 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 cyber-pattern opacity-30 pointer-events-none"></div>
      
      <div className="fx-container relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-3 font-bold text-2xl mb-6 text-foreground group">
              <FaronexoLogo
                variant="full"
                size={34}
                className="text-foreground group-hover:text-secondary transition-colors duration-300"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-md">
              Consultoría de seguridad minimalista y efectiva. Protegemos tu negocio con diagnósticos y soluciones adaptadas a tu empresa.
            </p>
            <div className="mt-6 flex items-center gap-2 text-secondary/80 text-sm font-medium">
              <SecurityIcon name="shield" size={16} className="text-secondary" />
              <span>Seguridad por diseño</span>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-3 lg:col-start-7">
            <span className="block font-semibold text-lg mb-6 text-foreground">Enlaces Rápidos</span>
            <nav className="flex flex-col gap-4">
              <Link to="/" className="text-muted-foreground hover:text-secondary transition-colors">
                Home
              </Link>
              <Link to="/servicios" className="text-muted-foreground hover:text-secondary transition-colors">
                Servicios
              </Link>
              <Link to="/solicitar-evaluacion" className="text-muted-foreground hover:text-secondary transition-colors">
                Solicitar evaluación
              </Link>
              <a href="https://console.faronexo.com/" className="text-muted-foreground hover:text-secondary transition-colors">
                Acceder a la consola
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <span className="block font-semibold text-lg mb-6 text-foreground">Contacto</span>
            <div className="flex flex-col gap-4">
              <a href="mailto:contactos@faronexo.com" className="flex items-center gap-3 text-muted-foreground hover:text-secondary transition-colors">
                <Mail className="w-5 h-5 text-secondary/70" />
                <span>contactos@faronexo.com</span>
              </a>
              <div className="flex items-center gap-3 text-muted-foreground">
                <MapPin className="w-5 h-5 text-secondary/70" />
                <span>Buenos Aires, Argentina</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary/30 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Faronexo. Todos los derechos reservados.
          </p>
          <div className="flex gap-6">
            <Link to="/politica-privacidad" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
              Política de Privacidad
            </Link>
            <Link to="/terminos-condiciones" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
              Términos y Condiciones
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
